import { IoTrash } from 'react-icons/io5'
import { IconButton } from '@chakra-ui/react'
import { Button, AlertDialog } from 'uikit'
import { useUserItemDelete } from './useUserItemDelete'
import { useHistory } from 'react-router-dom'
import { useState } from 'react'

export const Delete = ({ id, isReadOnly }) => {
  const history = useHistory()
  const [isOpen, setIsOpen] = useState(false)
  const { mutate: deleteItem, isPending: isLoadingDeleteItem } = useUserItemDelete()

  const handleDelete = () => {
    deleteItem(id, {
      onSuccess: () => {
        history.goBack()
      },
    })
  }

  return (
    <>
      <IconButton
        aria-label="Delete"
        borderRadius="full"
        onClick={() => setIsOpen(true)}
        disabled={isReadOnly}
      >
        <IoTrash />
      </IconButton>
      <AlertDialog
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        title="Удаление пользователя"
        footer={
          <>
            <Button onClick={() => setIsOpen(false)}>Отмена</Button>
            <Button loading={isLoadingDeleteItem} colorPalette="red" ml={3} onClick={handleDelete}>
              Удалить
            </Button>
          </>
        }
      >
        Вы действительно хотите удалить пользователя?
      </AlertDialog>
    </>
  )
}
